"use client";

import { useRouter } from "next/navigation";
import { useState, useTransition } from "react";
import { remixBook } from "@/lib/actions/authoring";

export function RemixButton({ slug, signedIn }: { slug: string; signedIn: boolean }) {
  const router = useRouter();
  const [pending, start] = useTransition();
  const [error, setError] = useState(false);

  function onClick() {
    if (!signedIn) {
      router.push("/signin?next=" + encodeURIComponent(`/books/${slug}`));
      return;
    }
    start(async () => {
      setError(false);
      try {
        // Success redirects to the new book's studio; only a failure returns here.
        await remixBook(slug);
      } catch {
        setError(true);
      }
    });
  }

  return (
    <>
      <button
        onClick={onClick}
        disabled={pending}
        className="flex h-[44px] w-full items-center justify-center gap-1.5 rounded-[12px] border bg-transparent text-[13.5px] font-bold text-copper transition-colors hover:bg-copper-light-3 disabled:opacity-60"
        style={{ borderColor: "#E4C9B3" }}
      >
        <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
          <path d="M11 2l3 3-3 3M14 5H6a3 3 0 00-3 3M5 14l-3-3 3-3M2 11h8a3 3 0 003-3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        {pending ? "Remixing…" : "Remix This Book"}
      </button>
      {error && (
        <p className="mt-2 text-[12.5px] font-semibold text-danger" role="alert">
          The remix didn&apos;t start — try again.
        </p>
      )}
    </>
  );
}
